"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EditorialRubricheHero() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = Math.min(scrollY * 0.15, 40);
  return <section data-section-id="2778" id="editorialrubrichehero" className="bg-background text-foreground relative overflow-hidden min-h-[60vh] md:min-h-[70vh] lg:min-h-[100vh] flex items-center ![padding:0px_1px_0px_1px] bg-cover bg-center md:bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/blog_hero_background.webp)]">
      <div className="absolute inset-0 z-0 bg-background/60" />

      <div className="w-full max-w-2xl mx-auto px-4 md:px-6 lg:px-16 py-16 md:py-24 lg:py-32 z-10">
        <div className="flex flex-col items-start justify-center md:grid md:grid-cols-12 gap-x-4 md:gap-x-6 gap-y-8 md:gap-y-12">
          
          <div ref={labelRef} className={`col-span-12 md:col-span-12 text-left transition-all duration-1000 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-xs md:text-sm uppercase tracking-widest text-primary">
              CONTENUTI ORIGINALI
            </p>
          </div>

          <div className="col-span-12 md:col-span-12">
            <h1 className="font-default font-light text-foreground text-left" style={{
            fontSize: "clamp(32px, 8vw, 168px)",
            lineHeight: "0.92",
            letterSpacing: "-0.02em"
          }}>Blog</h1>
          </div>

          <div ref={paragraphRef} className={`col-span-12 md:col-span-12 transition-all duration-1000 ease-out delay-300 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} max-w-full`}>
            <p className="font-default text-[17px] leading-relaxed text-white/70 mb-8 text-left">
              Ogni settimana, tre rubriche. Tre punti di vista che non trovi altrove.
            </p>
            <div className="flex justify-start">
              <Link to="/ContactsPage">
                <Button size="lg" className="rounded-lg bg-primary text-black hover:bg-primary/90 px-7 h-12 font-default text-sm tracking-wide shadow-md">
                  Inizia il Progetto
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>

          <div ref={imageRef} className={`hidden md:block col-span-12 md:col-span-4 md:col-start-9 transition-all duration-1000 ease-out delay-500 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transform: imageVisible ? `translateY(${-parallaxOffset}px)` : "translateY(2rem)"
        }}>
            {}
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="absolute left-0 right-0 bottom-0 h-px bg-slate-200" />
    </section>;
}